/**
 * Custom BarChartComponent - Child Class
 * Extends parent and overrides bar color to red/pink
 */
import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as echarts from 'echarts';
import { BarChartComponent as ParentBarChartComponent } from '@shared-lib/chart-components/bar-chart/bar-chart.component';
import { ConfigService } from '@shared-lib/shared-services/config.service';
import { GlobalFilterService } from '@shared-lib/shared-services/global-filter-service';
import { ChartFilterHandlerService } from '@shared-lib/shared-services/chart-filter-handler.service';

@Component({
  selector: 'app-bar-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent extends ParentBarChartComponent implements AfterViewInit, OnDestroy {

  private customChart!: echarts.ECharts;

  constructor(
    private customConfigService: ConfigService,
    private customGlobalFilterService: GlobalFilterService,
    protected override chartFilterHandler: ChartFilterHandlerService
  ) {
    super(customConfigService, customGlobalFilterService, chartFilterHandler);

    // Subscribe to filter changes
    this.customGlobalFilterService.filter$.subscribe((filters) => {
      if (Object.keys(filters).length !== 0) {
        this.loadCustomChart(filters);
      }
    });
  }

  override ngAfterViewInit(): void {
    this.loadCustomChart();
  }

  private loadCustomChart(filters?: any): void {
    const chartDom = document.getElementById(this.data.widgetId);
    if (!chartDom) return;

    if (!this.customChart) {
      this.customChart = echarts.init(chartDom);
    }

    this.customChart.showLoading();

    this.customConfigService.getConfig(this.data.apiUrl, filters).subscribe({
      next: (res) => {
        this.renderCustomChart(res?.data);
      },
      error: () => {
        this.customChart.hideLoading();
      }
    });
  }

  private renderCustomChart(chartData?: { category: string[]; value: number[] }): void {
    if (!this.data) return;

    const option = {
      tooltip: { trigger: 'axis' },
      xAxis: {
        type: 'category',
        data: chartData?.category || []
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          type: 'bar',
          data: chartData?.value || [],
          // OVERRIDE: Changed color from '#5470C6' to pink/red
          itemStyle: { color: '#e91e2fff' }
        }
      ]
    };

    this.customChart.setOption(option);
    setTimeout(() => {
      this.customChart.hideLoading();
    }, 1000);

    window.addEventListener('resize', () => this.customChart?.resize());
  }

  override ngOnDestroy(): void {
    this.customChart?.dispose();
  }
}
